/** Help's addresses and small pure shapes (#1294), apart from its components. */

/**
 * Help's own Desk parameter (docs/delivery/opus/DESK-FIRST.md): exactly one
 * `help=open`, `help=session:S` or `help=work:A` opens the learner's Help box
 * there. Anything else, a second `help`, an unknown kind, an empty id or an
 * extra `:`, is plain Desk: one deterministic rule, never a guess at intent.
 */
export const HELP_PARAM = "help";
export type HelpArrival = { kind: "session" | "work"; id: string } | "open" | null;

export function readHelpArrival(params: URLSearchParams): HelpArrival {
  const values = params.getAll(HELP_PARAM);
  if (values.length !== 1) return null;
  const [value] = values;
  if (value === "open") return "open";
  const exact = /^(session|work):([^:]+)$/.exec(value);
  return exact ? { kind: exact[1] as "session" | "work", id: exact[2] } : null;
}

/** The Desk address that opens Help about one session or piece of work. */
export function helpHref(courseHref: string, reference?: { kind: "session" | "work"; id: string }) {
  return `${courseHref}?${HELP_PARAM}=${reference ? `${reference.kind}:${encodeURIComponent(reference.id)}` : "open"}`;
}

/** The session's own words for a Help reference, as the server labels it. */
export function sessionHelpLabel(session: { session_no: number | null; label: string | null }) {
  return [session.session_no !== null ? `Session ${session.session_no}` : null, session.label].filter(Boolean).join(" · ") || null;
}

export function formatRetentionDate(value: string): string {
  const day = new Date(`${value}T00:00:00Z`);
  return Number.isNaN(day.getTime()) ? value : day.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", timeZone: "UTC" });
}
